import React, { MutableRefObject, useEffect, useRef, useState } from 'react'
import AgTechLoadingSurface from '../Pages/Loading/AgTechLoadingSurface';

export type AgTechPdfViewerProps = {
    file?: File
}

export type AgTechPdfHandler = {
    print: () => void,
    download: (fileName: string) => void,
    object: HTMLObjectElement,
    url: string
}

const AgTechPdfViewer = React.forwardRef<AgTechPdfHandler, AgTechPdfViewerProps>((props, ref) => {
    const objectRef = useRef<HTMLObjectElement>(null);

    const [isLoading, setIsLoading] = useState(true);
    const [blobUrl, setBlobUrl] = useState<string | null>(null);

    useEffect(() => {
        // Create a blob URL when the file is provided
        if (props.file) {
            const url = URL.createObjectURL(props.file) + '#view=FitH';
            setBlobUrl(url);

            setTimeout(() => {
                setIsLoading(false); // Assume rendering is complete
            }, 500);

            const inputRef = ref as MutableRefObject<AgTechPdfHandler>;

            if (inputRef) {
                inputRef.current = {
                    print: () => {
                        var iframe = document.createElement('iframe');
                        iframe.style.display = 'none'; // Hide the iframe
                        iframe.src = url; // Set the source to your PDF file
                    
                        // Append the iframe to the body
                        document.body.appendChild(iframe);
                    
                        // Wait for the iframe to load the PDF
                        iframe.onload = function() {
                            // Trigger the print dialog
                            iframe.contentWindow?.print();
                        };

                        // Use onafterprint to clean up the iframe
                        const cleanUp = () => {
                            document.body.removeChild(iframe);
                            window.removeEventListener('afterprint', cleanUp);
                        };
                
                        window.addEventListener('afterprint', cleanUp);
                    },
                    download: (fileName) => {
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = fileName;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                    },
                    object: objectRef.current as HTMLObjectElement,
                    url: url
                }
            }

            // Clean up the blob URL to prevent memory leaks
            return () => URL.revokeObjectURL(url);
        }
    }, [props.file]);

    return (
        <div className='stretched relative flex'>
            {isLoading && (
                <div className="stretched absolute centered container">
                    <div className="loader" />
                </div>
            )}
            {props.file && blobUrl ? (
                <>
                    <object
                        ref={objectRef}
                        data={blobUrl}
                        type='application/pdf'
                        className={`tall wide border ${isLoading ? 'opacity-0' : 'fade-in-400'}`}
                    >
                        <p>
                            Your browser doesn't support PDFs. You can download the PDF instead:{" "}
                            <a href={blobUrl} target="_blank" rel="noopener noreferrer">
                                Download PDF
                            </a>
                        </p>
                    </object>
                </>
            )
            : null}
        </div>
    )
})

export default AgTechPdfViewer